import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {STRING_CONSTANTS} from "@config/constants/string.constants";
import {FormControl, FormControlName, FormGroupDirective} from "@angular/forms";

@Component({
  selector: 'app-input-counter-number',
  templateUrl: './input-counter-number.component.html',
  styleUrls: ['./input-counter-number.component.scss']
})
export class InputCounterNumberComponent implements OnInit {

  protected readonly STRING_CONSTANTS = STRING_CONSTANTS;
  @Input() minimum: number=0;
  @Input() maximum: number;
  @Input() defaultValue: number;
  @Input() loadingFetch: boolean;

  protected counter: FormControl;


  get counterValue() {
    return this.formatValue(this.counter.value);
  }

  formatValue(value: string) {
    if (value) {
      let _val = value.toString().replace(/\D/g, '').replace(/^0+/, '');
      return +_val;
    }
    return 0;
  }

  inputShouldDisabled(): boolean {
    if (this.loadingFetch) return true;

    return this.isValidQtyFullFilled() && this.maximum < 1;
  }

  buttonAddShouldDisabled() {
    if (this.loadingFetch) return true;
    return this.counter.value >=  this.maximum;
  }

  constructor(private formControlNameDirective: FormControlName,
              private formGroupDirective: FormGroupDirective) {
  }

  decrement() {
    let _count = this.counterValue - 1;
    this.patchCounterValue(_count);
  }

  increment() {
    let _count = this.counterValue ? this.counterValue : 0;
    _count++;
    this.patchCounterValue(_count);
  }

  ngOnInit(): void {
    this.counter = this.formGroupDirective.getControl(this.formControlNameDirective);
  }


  isValidQtyFullFilled = () => {
    return this.counterValue <= this.maximum;
  };

  handleChangeInput() {
    let _val = this.counterValue;
    const _isValidQty = this.isValidQtyFullFilled();
    if (!_isValidQty) _val = this.defaultValue;
    this.patchCounterValue(_val);
  }

  patchCounterValue = (val: number) => {
    this.counter.patchValue(val);
  };

}
